/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Sortby_Creationdate2Inputs */

const id_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal Pembuatan`)
};

const ms_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh Penciptaan`)
};

const da_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oprettelsesdato`)
};

const de_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellungsdatum`)
};

const en_us2_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creation Date`)
};

const es_es2_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de creación`)
};

const es_mx2_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de creación`)
};

const fil_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa ng Paggawa`)
};

const fr_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de création`)
};

const it_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data di creazione`)
};

const hu_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Létrehozás dátuma`)
};

const nl_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanmaakdatum`)
};

const no_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opprettelsesdato`)
};

const pl_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data utworzenia`)
};

const pt_br2_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de criação`)
};

const pt_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de criação`)
};

const ro_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data creării`)
};

const fi_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luontipäivä`)
};

const sv_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapelsedatum`)
};

const vi_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày tạo`)
};

const tr_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oluşturulma Tarihi`)
};

const cs_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum vytvoření`)
};

const bg_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата на създаване`)
};

const ru_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата создания`)
};

const uk_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата створення`)
};

const ar_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ الإنشاء`)
};

const hi_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्माण तिथि`)
};

const th_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่สร้าง`)
};

const ja_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成日`)
};

const zh_cn2_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建日期`)
};

const zh_hant1_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立日期`)
};

const ko_tags_sortby_creationdate2 = /** @type {(inputs: Tags_Sortby_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생성일`)
};

/**
* | output |
* | --- |
* | "Creation Date" |
*
* @param {Tags_Sortby_Creationdate2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const tags_sortby_creationdate2 = /** @type {((inputs?: Tags_Sortby_Creationdate2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Sortby_Creationdate2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tags_sortby_creationdate2(inputs)
	if (locale === "ms") return ms_tags_sortby_creationdate2(inputs)
	if (locale === "da") return da_tags_sortby_creationdate2(inputs)
	if (locale === "de") return de_tags_sortby_creationdate2(inputs)
	if (locale === "en-US") return en_us2_tags_sortby_creationdate2(inputs)
	if (locale === "es-ES") return es_es2_tags_sortby_creationdate2(inputs)
	if (locale === "es-MX") return es_mx2_tags_sortby_creationdate2(inputs)
	if (locale === "fil") return fil_tags_sortby_creationdate2(inputs)
	if (locale === "fr") return fr_tags_sortby_creationdate2(inputs)
	if (locale === "it") return it_tags_sortby_creationdate2(inputs)
	if (locale === "hu") return hu_tags_sortby_creationdate2(inputs)
	if (locale === "nl") return nl_tags_sortby_creationdate2(inputs)
	if (locale === "no") return no_tags_sortby_creationdate2(inputs)
	if (locale === "pl") return pl_tags_sortby_creationdate2(inputs)
	if (locale === "pt-BR") return pt_br2_tags_sortby_creationdate2(inputs)
	if (locale === "pt") return pt_tags_sortby_creationdate2(inputs)
	if (locale === "ro") return ro_tags_sortby_creationdate2(inputs)
	if (locale === "fi") return fi_tags_sortby_creationdate2(inputs)
	if (locale === "sv") return sv_tags_sortby_creationdate2(inputs)
	if (locale === "vi") return vi_tags_sortby_creationdate2(inputs)
	if (locale === "tr") return tr_tags_sortby_creationdate2(inputs)
	if (locale === "cs") return cs_tags_sortby_creationdate2(inputs)
	if (locale === "bg") return bg_tags_sortby_creationdate2(inputs)
	if (locale === "ru") return ru_tags_sortby_creationdate2(inputs)
	if (locale === "uk") return uk_tags_sortby_creationdate2(inputs)
	if (locale === "ar") return ar_tags_sortby_creationdate2(inputs)
	if (locale === "hi") return hi_tags_sortby_creationdate2(inputs)
	if (locale === "th") return th_tags_sortby_creationdate2(inputs)
	if (locale === "ja") return ja_tags_sortby_creationdate2(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_sortby_creationdate2(inputs)
	if (locale === "zh-Hant") return zh_hant1_tags_sortby_creationdate2(inputs)
	return ko_tags_sortby_creationdate2(inputs)
});
export { tags_sortby_creationdate2 as "tags.sortBy.creationDate" }